import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getSentimentSymbol(theme) {
  if (theme.positiveCount > theme.negativeCount) {
    return '+';
  }
  if (theme.negativeCount > theme.positiveCount) {
    return '-';
  }
  return '~';
}
function renderExcerptText(excerpt) {
  const {
    text,
    highlightPhrases
  } = excerpt;
  if (!highlightPhrases || highlightPhrases.length === 0) {
    return `“${text}”`;
  }
  const escapedPhrases = highlightPhrases.map(phrase => phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const pattern = new RegExp(`(${escapedPhrases.join('|')})`, 'gi');
  const parts = text.split(pattern);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [`"`, parts.map((part, index) => {
      const isHighlight = highlightPhrases.some(phrase => phrase.toLowerCase() === part.toLowerCase());
      if (isHighlight) {
        return /*#__PURE__*/_jsx("strong", {
          children: part
        }, index);
      }
      return part;
    }), `"`]
  });
}
export function ReviewThemeTags({
  themes,
  onThemeSelected,
  onExcerptReadMore
}) {
  const [selectedThemeLabel, setSelectedThemeLabel] = useState(null);
  const handleTagClick = useCallback(label => {
    const nextLabel = selectedThemeLabel === label ? null : label;
    setSelectedThemeLabel(nextLabel);
    if (nextLabel) {
      onThemeSelected === null || onThemeSelected === void 0 || onThemeSelected(label);
    }
  }, [selectedThemeLabel, onThemeSelected]);
  const selectedTheme = themes.find(theme => theme.label === selectedThemeLabel);
  if (themes.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      typography: "heading-25",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.themes.selectToLearnMore"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexWrap: "wrap",
      marginBlockStart: "200",
      children: themes.map(theme => {
        const totalCount = theme.positiveCount + theme.negativeCount;
        const isSelected = selectedThemeLabel === theme.label;
        return /*#__PURE__*/_jsx(View, {
          marginInlineEnd: "200",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsxs(Tag, {
            use: isSelected ? 'active' : 'default',
            cursor: "pointer",
            onClick: () => handleTagClick(theme.label),
            children: [getSentimentSymbol(theme), " ", theme.label, " (", totalCount, ")"]
          })
        }, theme.label);
      })
    }), selectedTheme && /*#__PURE__*/_jsxs(View, {
      borderRadius: "200",
      marginBlockStart: "400",
      padding: "600",
      backgroundColor: "fill-surface-default",
      borderInlineStartWidth: "300",
      borderInlineStartColor: "border-accent-blue-default",
      position: "relative",
      children: [/*#__PURE__*/_jsx(CloseButton, {
        color: "icon-core-subtle",
        onClick: () => setSelectedThemeLabel(null)
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: "200",
        marginBlockEnd: "400",
        flexWrap: "wrap",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.themes.customersMention",
            options: {
              count: selectedTheme.positiveCount + selectedTheme.negativeCount,
              label: selectedTheme.label
            }
          })
        }), selectedTheme.positiveCount > 0 && /*#__PURE__*/_jsx(Text, {
          color: "fill-accent-green-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.themes.positive",
            options: {
              count: selectedTheme.positiveCount
            }
          })
        }), selectedTheme.negativeCount > 0 && /*#__PURE__*/_jsx(Text, {
          color: "text-alert-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.themes.negative",
            options: {
              count: selectedTheme.negativeCount
            }
          })
        })]
      }), selectedTheme.excerpts.map(excerpt => /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsxs(Small, {
          children: [renderExcerptText(excerpt), /*#__PURE__*/_jsx(Link, {
            marginInlineStart: "200",
            onClick: () => onExcerptReadMore === null || onExcerptReadMore === void 0 ? void 0 : onExcerptReadMore(excerpt.text, excerpt.reviewId),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-reviews.themes.readMore"
            })
          })]
        })
      }, excerpt.reviewId))]
    })]
  });
}